// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

import { type Scope } from "~/hooks/useScope";
import { GET } from "./action";

export function canGet(scope: Scope): boolean {
  return scope.iamActions.includes(GET);
}
